export default __webpack_public_path__ + "static/media/img-0200-columbia-full-face.3e730320.png";